import { ButtonGroup, Input } from "@transfr-inc/dashboard-components/forms";

import {
  CRITERIA_FREE_TEXT_MAX,
  INDUSTRY_AREA_OPTIONS,
  MATCH_FLEXIBILITY_OPTIONS,
  PROGRAM_TYPE_OPTIONS,
  USAGE_FREQUENCY_OPTIONS,
} from "../ai-curriculum.constants";

import { DropdownField, readValue } from "./ai-form-field";

// Field group for the Upload Syllabus path. Prefilled from the analyzer's
// suggestedCriteria — every value stays editable before submit.
export const SyllabusUploadFields = ({ criteria, errors, onChange }) => {
  const isOther = criteria.industryArea?.id === "other";

  const segmentedButtons = (options, field) =>
    options.map((o) => ({
      label: o.name,
      id: o.id,
      onClick: () => onChange({ [field]: o }),
    }));

  return (
    <div className="ai-form-step__fields">
      <DropdownField
        label="Industry"
        placeholder="Select an industry area"
        options={INDUSTRY_AREA_OPTIONS}
        selected={criteria.industryArea}
        required
        error={errors.industryArea}
        onChange={(industryArea) => onChange({ industryArea })}
      />
      <label className="ai-form-step__field">
        <span className="ai-form-step__label">
          Career
          {isOther && <span className="required">*</span>}
        </span>
        <Input
          placeholder="e.g. Aviation maintenance, Veterinary assisting"
          maxLength={CRITERIA_FREE_TEXT_MAX}
          value={criteria.industrySpecifics}
          errors={errors.industrySpecifics}
          onChange={(e) => onChange({ industrySpecifics: readValue(e) })}
        />
        {errors.industrySpecifics && (
          <span className="ai-form-step__error" role="alert">
            {errors.industrySpecifics}
          </span>
        )}
      </label>
      <DropdownField
        label="Program Type"
        placeholder="Select a program type"
        options={PROGRAM_TYPE_OPTIONS}
        selected={criteria.programType}
        required
        error={errors.programType}
        onChange={(programType) => onChange({ programType })}
      />
      <DropdownField
        label="How Often Will You Use Transfr?"
        placeholder="Select a frequency"
        options={USAGE_FREQUENCY_OPTIONS}
        selected={criteria.usageFrequency}
        required
        error={errors.usageFrequency}
        onChange={(usageFrequency) => onChange({ usageFrequency })}
      />
      <div className="ai-form-step__field">
        <span className="ai-form-step__label">Match Flexibility</span>
        <ButtonGroup
          buttons={segmentedButtons(
            MATCH_FLEXIBILITY_OPTIONS,
            "matchFlexibility"
          )}
          selected={criteria.matchFlexibility?.id}
        />
      </div>
    </div>
  );
};
